module.exports = __webpack_public_path__ + "static/media/highlight.642c88dd.mp4";